import Box from '@enlighten/design-system/dist/Box';
import Typography from '@enlighten/design-system/dist/Typography';

interface CardCarouselChipProps {
	label: string;
	color?: string;
	bgcolor?: string;
}

const CardCarouselChip: React.FC<CardCarouselChipProps> = ({ label, color = '#1D1E1F', bgcolor = '#FFB300' }) => (
	<Box bgcolor={bgcolor} padding="4px 12px" borderRadius="8px">
		<Typography fontSize={{ xs: '14px', md: '20px' }} color={color}>
			{label}
		</Typography>
	</Box>
);

export default CardCarouselChip;
